var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('encabezado'),_c('breadcrum',{attrs:{"titulo":_vm.titulo,"texto":_vm.texto}}),_c('div',{staticStyle:{"padding-left":"10%"}},[_c('textos-index'),_c('formulario'),_c('boton-enviar')],1),_c('pie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }